import "./RiverdaleServiceArea.module.css";
import Header from "@/reusable_sections/Header";
import Riverdale from "./sections/Riverdale";
import ServicesGrid from "./sections/ServicesGrid";
import RiverdaleProblems from "./sections/RiverdaleProblems";
import Riverdalefaq from "./sections/Riverdalefaq";
import RiverdaleCta from "./sections/RiverdaleCta";
import Footer from "@/reusable_sections/Footer";
export default function RiverdaleServiceAreaPage() {
  return <div>
      <Header />
      <Riverdale />
      <ServicesGrid />
      <RiverdaleProblems />
      <Riverdalefaq />
      <RiverdaleCta />
      <Footer />
    </div>;
}